import { isBefore, startOfDay, parseISO, isValid } from 'date-fns';
import { ADRIATIC_LAST_SEARCH_PARAMS } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/constants';

const STORAGE_KEY = ADRIATIC_LAST_SEARCH_PARAMS;
const STORAGE_TTL_MS = 6 * 30 * 24 * 60 * 60 * 1000;

function hasExpiredDates(params) {
    if (!params.from) return false;
    const startDate = parseISO(params.from);
    if (!isValid(startDate)) return true;
    return isBefore(startOfDay(startDate), startOfDay(new Date()));
}

export function saveSearchParams(params) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ params, savedAt: Date.now() }));
    } catch (err) {
        // localStorage može baciti grešku u private modu, tiho zanemarujemo grešku jer je ovo nekritično.
    }
}

export function getSearchParams() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const { params, savedAt } = JSON.parse(raw);

        if (Date.now() - savedAt > STORAGE_TTL_MS) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }

        if (hasExpiredDates(params)) {
            const { from, to, ...paramsWithoutDates } = params;
            saveSearchParams(paramsWithoutDates);
            return paramsWithoutDates;
        }

        return params;
    } catch (err) {
        return null;
    }
}

export function clearSearchParams() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
        // Brisanje nije uspjelo (npr. localStorage nedostupan) - nije kritično, getSearchParams će svejedno odbaciti spremljeni unos u localStorage ako je istekao.
    }
}
